import { serviceMaker, methods, api } from "@/http/index.js";

export const voucherPinList = () =>
    serviceMaker(`/vouchers`, methods.GET, api.NGB);
export const voucherTemplate = () =>
    serviceMaker(`/vouchers/template`, methods.GET, api.NGB);
export const voucherPrices = () =>
    serviceMaker(`/prices`, methods.GET, api.NGB);
export const saveVoucherPin = (data) =>
    serviceMaker(`/vouchers`, methods.POST, api.NGB, data);
export const processVoucher = (id, data) =>
    serviceMaker(`/vouchers/${id}`, methods.POST, api.NGB, data);
export const voucherVoucherPinList = (id) =>
    serviceMaker(`/vouchers/voucherslist/${id}`, methods.GET, api.NGB);
export const voucherVoucherPinListWithStatus = (id, status) =>
    serviceMaker(
        `/vouchers/voucherslist/${id}?statusType=${status}`,
        methods.GET,
        api.NGB
    );
export const updateVoucher = (id, data) =>
    serviceMaker(`/vouchers/${id}`, methods.PUT, api.NGB, data);
export const deleteVoucher = (id, data) =>
    serviceMaker(`/vouchers/delete/${id}`, methods.POST, api.NGB, data);
export const downloadVoucher = (id) =>
    serviceMaker(`vouchers/${id}?tenantIdentifier=default`, methods.GET, api.NGB);
